<template>
  <div id="content" v-if="!loading">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form action="#">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: 'subscriberDetail', params: {id: entity.id_subscriber, tab: 'profiles'} }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <p v-if="isDeletable" class="buttons">
          <a @click.prevent.stop="deleteEntity(true, {path: 'subscriberDetail', params: {id: entity.id_subscriber}})" class="btn btn_action btn_delete" title="Smazat" v-translate>Smazat</a>
        </p>
        <h1>{{entity.name}}</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content" id="tab-1">
          <BasicInfo
              :profile="entity"
              :isEditable="isEditable"
          />
          <section class="buttons">
            <p>
              <router-link :to="{ name: 'subscriberDetail', params: {id: entity.id_subscriber, tab: 'profiles'} }" class="btn btn_back btn_seznam" v-translate>Seznam</router-link>
              <input
                  v-if="isEditable"
                  type="submit"
                  :value="'Uložit' | translate"
                  :class="['btn']"
                  @click.prevent.stop="submitForm()">
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"
import subscriberProfile from "./mixins/subscriberProfile";
import SelectImagePopup from "./SelectImagePopup.vue";
import BasicInfo from "./forms/BasicInfo.vue";

export default {
  name: "SubscriberProfileDetail",
  components: {BasicInfo},
  mixins: [detailActions, subscriberProfile],
  data() {
    return {
      entityName: 'subscriber_profile',
    }
  },
  created(SubscriberProfileService) {
    this.entityService = SubscriberProfileService
    this.createdInit();
  },
  computed: {
    isEditable(){
      return this.$_loggedUser_action_allowed(this.$route.meta.sectionName, 'update');
    },
    isDeletable(){
      return !this.entity.is_last_profile && this.$_loggedUser_action_allowed(this.$route.meta.sectionName, 'delete');
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscriberProfile/SubscriberProfileDetail.vue